import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overflow-y-hidden" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("iframe", {
      frameBorder: "0",
      onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.iframeLoaded && _ctx.iframeLoaded(...args))),
      width: "100%",
      height: "100%",
      style: {"border":"0"},
      src: _ctx.getKBURL()
    }, null, 40, _hoisted_2), [
      [_vShow, !_ctx.appLoading]
    ])
  ]))
}